export default class CommonTree {
    /**
     * @type {string}
     * @memberof CommonTree
     * @name id
     */
    public id:string;
    /**
     * @type {string}
     * @memberof CommonTree
     * @name 名称
     */
    public name:string;
    /**
     * @type {string}
     * @memberof CommonTree
     * @name 节点类型
     */
    public type:string;
    /**
     * @type {string}
     * @memberof CommonTree
     * action 有业务动作
     * expand 仅展开
     */
    public clickType:string;
    /**
     * @type {string}
     * @memberof CommonTree
     * @name 业务扩展属性
     */
    public extendProp:string;
    /**
     * @type {string}
     * @memberof CommonTree
     * @name 名称
     */
    public title: string;
    public key: string;
    public value: string;
    public children: CommonTree[];
    /**
     * @type {string}
     * @memberof CommonTree
     * @name 下级节点
     */
    public subNodes:CommonTree[];
    
    constructor({
        id = '',
        name = '',
        type = '',
        clickType = '',
        extendProp = '',
        subNodes = [],
        title = '',
        key = '',
        value = '',
        children = []
    }={}){
        this.id = id,
        this.name = name,
        this.type = type,
        this.clickType = clickType,
        this.extendProp = extendProp,
        this.subNodes = subNodes
        this.title = title,
        this.key = key,
        this.value = value
        this.children = children
    }
}